import bus from "../bus";
import { FLASH } from "../action-types";

export default function mailchimpForm(el) {
  const inputs = Array.prototype.slice.call(
    el.querySelectorAll("input:not([tabindex='-1'])")
  );
  el.addEventListener("submit", onSubmit);
  function onSubmit(e) {
    e.preventDefault();

    const callbackName = `mailchimpSignup${Date.now()}`;

    let action = el.getAttribute("action");
    action = action.replace("/post?u=", "/post-json?u=");
    // Get data from inputs
    let additionalParams = inputs.map(
      input =>
        `${input.getAttribute("name")}=${window.encodeURIComponent(
          input.value
        )}`
    );
    additionalParams = additionalParams.concat([`&c=${callbackName}`]);

    // Create script
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `${action}&${additionalParams.join("&")}`;

    // Setup handler
    window[callbackName] = function(response) {
      if (response.result && response.result === "error") {
        bus.emit(FLASH, {
          type: "alert",
          message: response.msg
        });
      } else {
        // Clear inputs
        inputs.forEach(input => {
          input.value = "";
        });
        bus.emit(FLASH, {
          type: "notice",
          message: "Thanks for subscribing!"
        });
      }

      document.getElementsByTagName("head")[0].removeChild(script);
      script = null;
      delete window[callbackName];
    };

    // Load JSON
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  return {
    destroy: () => {
      el.removeEventListener("submit", onSubmit);
    }
  };
}
